export default __webpack_public_path__ + "static/media/Tony.af8352ea.jpg";